(function () {
  'use strict';
  if (window.__caCollection) return;
  window.__caCollection = true;

  document.querySelectorAll('[data-ca-col]').forEach(function (root) {
    var grid = root.querySelector('[data-ca-col-grid]');
    if (!grid) return;
    var id = root.dataset.caColSection;
    var cards = Array.from(grid.querySelectorAll('[data-ca-col-card]'));
    var chips = Array.from(root.querySelectorAll('[data-ca-col-chip]'));
    var categories = Array.from(root.querySelectorAll('[data-ca-col-category]'));
    var select = root.querySelector('[data-ca-col-select]');
    var deals = root.querySelector('[data-ca-col-deals]');
    var more = root.querySelector('[data-ca-col-more]');
    var clear = root.querySelector('[data-ca-col-clear]');
    var count = root.querySelector('[data-ca-col-count]');
    var empty = root.querySelector('[data-ca-col-empty]');
    var pages = root.querySelector('[data-ca-col-pages]');
    var labels = JSON.parse(root.querySelector('[data-ca-col-labels]').textContent);
    var first = chips.find(function (chip) { return chip.getAttribute('aria-pressed') === 'true'; });
    var initial = first ? first.dataset.caColChip : 'all';
    var params = new URL(location.href).searchParams;
    var approach = params.get('ca_approach');
    var type = params.get('ca_type');
    var state = {
      chip: chips.some(function (chip) { return chip.dataset.caColChip === approach; }) ? approach : initial,
      type: categories.some(function (button) { return button.dataset.caColCategory === type; }) || select && Array.from(select.options).some(function (option) { return option.value === type; }) ? type : 'all',
      limit: Math.min(300, Math.max(0, Number(params.get('ca_limit')) || 0))
    };
    if (deals) deals.checked = params.get('ca_deals') === '1';
    var loading = pages && Number(pages.dataset.caColPage) === 1 && Number(pages.dataset.caColTotal) > 1;
    root.querySelectorAll('[data-ca-col-filters], [data-ca-col-chips]').forEach(function (node) { node.hidden = false; });

    function has(card, value) { return (' ' + card.dataset.caChips + ' ').includes(' ' + value + ' '); }
    function batch() { return Number(matchMedia('(max-width: 768px)').matches ? root.dataset.caColCap : root.dataset.caColCapDesktop); }
    function matches(card, filterType) {
      return (state.chip === 'all' || has(card, state.chip)) && (filterType === 'all' || has(card, filterType)) && (!deals || !deals.checked || has(card, 'deals'));
    }
    function save() {
      var url = new URL(location.href);
      [['ca_approach', state.chip], ['ca_type', state.type === 'all' ? '' : state.type], ['ca_deals', deals && deals.checked ? '1' : ''], ['ca_limit', state.limit || '']].forEach(function (entry) {
        if (entry[1]) url.searchParams.set(entry[0], entry[1]); else url.searchParams.delete(entry[0]);
      });
      history.replaceState(null, '', url);
    }
    function arrange() {
      cards.sort(function (a, b) { return Number(a.dataset.caSold) - Number(b.dataset.caSold); });
      cards.forEach(function (card) { grid.appendChild(card); });
    }
    function show() {
      var matching = cards.filter(function (card) { return matches(card, state.type); });
      var limit = Math.max(batch(), state.limit);
      cards.forEach(function (card) { card.hidden = true; });
      matching.slice(0, limit).forEach(function (card) { card.hidden = false; });
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.dataset.caColChip === state.chip ? 'true' : 'false');
      });
      categories.forEach(function (button) {
        var key = button.dataset.caColCategory;
        button.setAttribute('aria-pressed', key === state.type ? 'true' : 'false');
        button.hidden = key.indexOf('type:') === 0 && !loading && !cards.some(function (card) { return matches(card, key); });
      });
      if (select) {
        select.value = state.type;
        Array.from(select.options).forEach(function (option) {
          option.disabled = !loading && option.value !== 'all' && !cards.some(function (card) { return matches(card, option.value); });
        });
      }
      if (count) count.textContent = loading ? labels.loading : matching.length + ' ' + (matching.length === 1 ? labels.one : labels.other) + (!categories.length && matching.length && matching.every(function (card) { return card.dataset.caSold !== '1'; }) ? ', ' + labels.stock : '');
      if (empty) empty.hidden = loading || matching.length > 0;
      if (clear) clear.hidden = categories.length > 0 || state.type === 'all' && (!deals || !deals.checked);
      if (more) { more.hidden = matching.length <= limit; more.textContent = labels.more + ' (' + Math.max(0, Math.min(batch(), matching.length - limit)) + ')'; }
    }
    function changed() {
      state.limit = 0;
      show();
      save();
      try {
        if (window.clarity) window.clarity('event', 'ca_collection_filter');
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('ca_collection_filter', { chip: state.chip, type: state.type });
      } catch (error) {}
    }
    chips.forEach(function (chip) { chip.addEventListener('click', function () { state.chip = chip.dataset.caColChip; if (categories.length) state.type = 'all'; changed(); }); });
    categories.forEach(function (button) { button.addEventListener('click', function () { state.type = button.dataset.caColCategory; changed(); }); });
    if (select) select.addEventListener('change', function () { state.type = select.value; changed(); });
    if (deals) deals.addEventListener('change', changed);
    if (clear) clear.addEventListener('click', function () { state.type = 'all'; if (deals) deals.checked = false; if (select) select.focus(); changed(); });
    if (more) more.addEventListener('click', function () { state.limit = Math.max(batch(), state.limit) + batch(); show(); save(); });
    var sort = root.querySelector('[data-ca-col-sort]');
    if (sort) sort.addEventListener('change', function () {
      save();
      var url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      if (root.id) url.hash = root.id;
      location.href = url.toString();
    });
    window.addEventListener('resize', show);
    arrange();
    show();
    if (!loading) return;
    var total = Number(pages.dataset.caColTotal);
    var jobs = [];
    for (var page = 2; page <= Math.min(total, 6); page += 1) {
      var url = new URL(location.href);
      url.searchParams.set('page', page);
      url.searchParams.set('section_id', id);
      jobs.push(fetch(url).then(function (response) { if (!response.ok) throw new Error('page'); return response.text(); }));
    }
    Promise.all(jobs).then(function (texts) {
      texts.forEach(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.getElementById('shopify-section-' + id) || doc.body;
        cards.push.apply(cards, Array.from(section.querySelectorAll('[data-ca-col-card]')));
      });
      if (total <= 6) pages.hidden = true;
      arrange();
    }).catch(function () {}).finally(function () { loading = false; show(); });
  });
})();
